/* eslint max-params: ["error", 10]*/

import ImgSrcSet from './ImgSrcSet';
import { Image, JobAd, RealestateAd, CarAd, Geo } from '../types/ad';

function possessive (text?: string) {
    if (text) {
        if (text.toLowerCase().endsWith('.no')) {
            return `${text}’s`;
        }
        const last = text[text.length - 1].toLowerCase();
        switch (last) {
            case 's':
            case 'x':
            case 'z':
                return `${text}’`;

            default:
                return `${text}s`;
        }
    }
}

function quality (filename?: string) {
    if (filename) {
        const extension = filename
            .split('.')
            .pop()!
            .toLowerCase();
        switch (extension) {
            case 'svg':
                return 'excellent';
            case 'jpg':
                return 'poor';
            default:
                return 'average';
        }
    }
}

type Recommendation = {
    landscape: boolean;
    adId: string;
};

type UndocumentedInput = {
    size: string;
};

type Input = JobAd & RealestateAd & CarAd & Recommendation & UndocumentedInput;

export default class ResultItem {
    address?: string;
    size?: string;
    heading?: string;
    adId?: number | string;
    mainImage?: string;
    images?: Image[];
    logo?: string;
    logoQuality?: 'excellent' | 'poor' | 'average';
    svgLogo?: string;
    orgName?: string;
    orgId?: number;
    duration?: string;
    deadline?: string;
    postalName?: string;
    srcSet?: string | [];
    landscape?: boolean;
    geo?: Geo;
    shortHeading?: string;
    shortAddress?: string;
    adType?: string;
    priceAsText?: string | null;
    primaryM2?: string;
    mainPrice?: string;
    totalPrice?: string;
    sharedCost?: string;
    experimentalHeadingPrefix?: string;
    hasCustomHeading?: boolean;
    constructor ({
        address,
        size,
        heading,
        adId,
        mainImage,
        images = [],
        logo,
        svgLogo,
        orgName,
        orgId,
        duration,
        deadline,
        postalName,
        landscape = true,
        geo,
        shortHeading,
        shortAddress,
        adType,
        priceAsText,
        primaryM2,
        mainPrice,
        totalPrice,
        sharedCost,
    }: Partial<Input>) {
        this.address = address;
        this.size = size;
        this.heading = heading;
        this.hasCustomHeading = heading !== `${orgName} søker ${shortHeading}`;
        this.adId = adId;
        this.mainImage = images.length > 0 ? images[0].url : mainImage;
        this.images = images;
        this.logo = logo;
        this.logoQuality = quality(logo);
        this.svgLogo = svgLogo;
        this.orgName = orgName;
        this.orgId = orgId;
        this.duration = duration;
        this.deadline = deadline;
        this.postalName = postalName;
        this.landscape = landscape;
        this.srcSet = [];
        this.geo = geo;
        this.shortHeading = shortHeading;
        this.shortAddress = shortAddress;
        this.adType = adType;
        this.priceAsText = priceAsText ? priceAsText.replace(', ', '<br>') : null;
        this.primaryM2 = primaryM2;
        this.mainPrice = mainPrice;
        this.totalPrice = totalPrice;
        this.sharedCost = sharedCost;
        this.experimentalHeadingPrefix = `Er du ${possessive(orgName)} nye`;
        this.setSrcSet();
        this.setMainImage();
    }

    setSrcSet () {
        if (this.mainImage) {
            this.srcSet = new ImgSrcSet(this.mainImage).srcSet.join(',');
        }
    }

    setMainImage () {
        if (this.mainImage) {
            this.mainImage = this.mainImage.replace('/dynamic/default/', '/dynamic/960w/');
        }
    }

    toJSON () {
        const {
            address,
            size,
            heading,
            hasCustomHeading,
            adId,
            mainImage,
            logo,
            orgName,
            srcSet,
            landscape,
            geo,
            shortHeading,
            shortAddress,
            priceAsText,
            primaryM2,
            mainPrice,
            totalPrice,
            sharedCost,
        } = this;
        return {
            address,
            size,
            heading,
            hasCustomHeading,
            adId,
            mainImage,
            logo,
            orgName,
            srcSet,
            landscape,
            geo,
            shortHeading,
            shortAddress,
            priceAsText,
            primaryM2,
            mainPrice,
            totalPrice,
            sharedCost,
        };
    }
}
